define('bizzabo/views/popup/DeleteSessionView',[
    'jquery',
    'backbone',
    'bizzabo/views/popup/PopupView',
    'bizzabo/models/Global',
    'hbars!bizzabo/templates/deletePoll',
    'bizzabo/consts'
], function(
    $,
    Backbone,
    PopupView,
    Global,
    template,
    Consts
    ) {

    var DeleteSessionView = PopupView.extend({

        events : {
            'click .denyButton' : 'denyClicked',
            'click .allowButton' : 'allowClicked'
        },

        initialize : function(options) {
            this.onDelete = options.onDelete;
            this.popUpInitialize();
            this.model.set('title', options.title);
            this.model.set('html', options.html);
        },

        render : function() {
            var html = template(this.model.toJSON());
            this.$el.html(html);
            return this;
        },

        denyClicked : function() {
            this.hide();
        },

        allowClicked : function() {
            this.onDelete();
            this.hide();
        }

    });

    return DeleteSessionView;

});
